import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIOverlay from 'UIComponents/overlay/UIOverlay';
import { PUBLISHING_OVERLAY_WIDTH } from '../../constants/ModalConstants';
import styled from 'styled-components';
import { OLAF } from 'HubStyleTokens/colors';
import { URANUS_LAYER } from 'HubStyleTokens/sizes';
import { padding } from 'UIComponents/styles/spacing';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledPublishingOverlay = styled(UIOverlay).withConfig({
  displayName: "PublishingOverlay__StyledPublishingOverlay",
  componentId: "sc-19ei0i8-0"
})(["", ";color:", ";z-index:", ";"], padding('y', 0), OLAF, URANUS_LAYER);
class PublishingOverlay extends Component {
  render() {
    return /*#__PURE__*/_jsx(StyledPublishingOverlay, {
      width: PUBLISHING_OVERLAY_WIDTH,
      children: /*#__PURE__*/_jsx(UIFlex, {
        align: "center",
        direction: "column",
        justify: "center",
        style: {
          height: window.innerHeight
        },
        children: /*#__PURE__*/_jsxs(UIBox, {
          alignSelf: "start",
          children: [/*#__PURE__*/_jsx(UILoadingSpinner, {
            grow: true
          }), /*#__PURE__*/_jsx("h5", {
            className: "m-top-4",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "knowledgeContentUI.shared.publishing"
            })
          })]
        })
      })
    });
  }
}
export default PublishingOverlay;